<div class="col se-p is-notification second-level-menu">
  <div class="menu-options level is-marginless display-flex">
    <div class="level-left">
      <div class="level-item">
        <div class="select is-small">
          <select>
            <option>Sort A to Z</option>
            <option>Sort by Recent</option>
          </select>
        </div>
      </div>
    </div>
    <div class="level-right">
      <div class="level-item">
        <a class="is-small button">
          <i class="fa fa-search"></i>
        </a>
        <a
          class="is-small button"
          (click)="welcomeWindow('welcome')"
          title="Add new user"
        >
          <i class="fa-solid fa-circle-plus" aria-hidden="true"></i>
        </a>
      </div>
    </div>
  </div>
  <div class="list-wrapper scroll-bar list-overflow">
    <ul>
      <li
        class="cursor-pointer"
        [routerLink]="['/connections', 5]"
        routerLinkActive="active"
      >
        <div class="columns display-flex is-gapless">
          <div class="column is-one-quarter">
            <img [src]="'../../../assets/images/slack-icon-10.png'" />
          </div>
          <div class="column is-clearfix">
            <div class="is-pulled-left">
              <label class="is-size-5">Slack</label>
            </div>
            <div class="is-pulled-right">
              <span class="is-size-7">Mar 03</span>
            </div>
          </div>
        </div>
      </li>
      <li class="cursor-pointer">
        <div class="columns is-gapless display-flex">
          <div class="column is-one-quarter">
            <img [src]="'../../../assets/images/Amazon_SNS-320x320.png'" />
          </div>
          <div class="column is-clearfix">
            <div class="is-pulled-left">
              <label class="is-size-5">Amazon SNS</label>
            </div>
            <div class="is-pulled-right">
              <span class="is-size-7">Feb 26</span>
            </div>
          </div>
        </div>
      </li>
      <li class="cursor-pointer">
        <div class="columns is-gapless display-flex">
          <div class="column is-one-quarter">
            <img
              [src]="'../../../assets/images/icon-pd-white-1024-300x300.png'"
            />
          </div>
          <div class="column is-clearfix">
            <div class="is-pulled-left">
              <label class="is-size-5">Pagerduty</label>
            </div>
            <div class="is-pulled-right">
              <span class="is-size-7">Feb 22</span>
            </div>
          </div>
        </div>
      </li>
      <li class="cursor-pointer">
        <div class="columns is-gapless display-flex">
          <div class="column is-one-quarter">
            <img [src]="'../../../assets/images/unnamed.png'" />
          </div>
          <div class="column is-clearfix">
            <div class="is-pulled-left">
              <label class="is-size-5">Glip</label>
            </div>
            <div class="is-pulled-right">
              <span class="is-size-7">Feb 15</span>
            </div>
          </div>
        </div>
      </li>
      <li class="cursor-pointer" ng-click="showldap=!showldap">
        <div class="columns is-gapless display-flex">
          <div class="column is-one-quarter">
            <img [src]="'../../../assets/images/simpleid-icon-ldap.svg'" />
          </div>
          <div class="column is-clearfix">
            <div class="is-pulled-left">
              <label class="is-size-5">LDAP</label>
            </div>
            <div class="is-pulled-right">
              <span class="is-size-7">Jan 28</span>
            </div>
          </div>
        </div>
      </li>
      <li class="cursor-pointer">
        <div class="columns is-gapless display-flex">
          <div class="column is-one-quarter">
            <img [src]="'../../../assets/images/icondatabase.png'" />
          </div>
          <div class="column is-clearfix">
            <div class="is-pulled-left">
              <label class="is-size-5">Active Directory</label>
            </div>
            <div class="is-pulled-right">
              <span class="is-size-7">Jan 15</span>
            </div>
          </div>
        </div>
      </li>
      <li class="cursor-pointer">
        <div class="columns is-gapless display-flex">
          <div class="column is-one-quarter">
            <img [src]="'../../../assets/images/twilio.svg'" />
          </div>
          <div class="column is-clearfix">
            <div class="is-pulled-left">
              <label class="is-size-5">Twillio</label>
            </div>
            <div class="is-pulled-right">
              <span class="is-size-7">Jan 14</span>
            </div>
          </div>
        </div>
      </li>
      <li class="cursor-pointer">
        <div class="columns is-gapless display-flex">
          <div class="column is-one-quarter">
            <img [src]="'../../../assets/images/jira.png'" />
          </div>
          <div class="column is-clearfix">
            <div class="is-pulled-left">
              <label class="is-size-5">Jira</label>
            </div>
            <div class="is-pulled-right">
              <span class="is-size-7">Jan 10</span>
            </div>
          </div>
        </div>
      </li>
      <li class="cursor-pointer">
        <div class="columns is-gapless display-flex">
          <div class="column is-one-quarter">
            <img [src]="'../../../assets/images/AlexaSupport_8.png'" />
          </div>
          <div class="column is-clearfix">
            <div class="is-pulled-left">
              <label class="is-size-5">Alexa</label>
            </div>
            <div class="is-pulled-right">
              <span class="is-size-7">Jan 09</span>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</div>

@if (false) {
<div
  class="modal welcome-window"
  [ngClass]="{ 'is-active': showWelcomeWindow }"
>
  <div class="modal-background"></div>
  <div class="modal-content">
    @if (welcomeWindowName === 'welcome') {
    <div class="box">
      <div class="columns">
        <div class="column is-12 has-text-centered">
          <h2>Welcome to Canstring</h2>
          <h4>You've successfully signed up</h4>
          <p>
            Canstring is a multi-channel communications platform created to help
            people connect and discuss about any topic.
          </p>
        </div>
      </div>
      <div class="columns has-text-centered">
        <div class="column is-12">
          <a
            class="button is-link is-small"
            (click)="welcomeWindow('createWindow')"
            >Explore Canstring</a
          >
        </div>
      </div>
    </div>
    } @if (welcomeWindowName === 'createWindow') {
    <div class="box">
      <div class="columns">
        <div class="column is-12">
          <p>
            You can start your discussion by creating your own topic and share
            it publicly or you can create topic and invite only the people you
            want to discuss with, it's like a private topic other users can't
            join or access the topic, until you invite.
          </p>
        </div>
      </div>
      <div class="columns">
        <div class="column is-12">
          <img [src]="'../../../assets/images/new-chat.png'" />
        </div>
      </div>
      <div class="columns">
        <div class="column is-6">
          <a class="button is-small" (click)="welcomeWindow('')">Skip</a>
        </div>
        <div class="column is-6 has-text-right">
          <a
            class="button is-link is-small"
            (click)="welcomeWindow('menuOptions')"
            >Next</a
          >
        </div>
      </div>
    </div>
    } @if (welcomeWindowName === 'menuOptions') {
    <div class="box">
      <div class="columns">
        <div class="column is-12">
          <p>
            You can start your discussion by creating your own topic and share
            it publicly.
          </p>
        </div>
      </div>
      <div class="columns">
        <div class="column is-12">
          <img [src]="'../../../assets/images/menu-options.png'" />
        </div>
      </div>
      <div class="columns">
        <div class="column is-6">
          <a class="button is-small" (click)="welcomeWindow()">Skip</a>
        </div>
        <div class="column is-6 has-text-right">
          <a
            class="button is-link is-small"
            (click)="welcomeWindow('createWindow')"
            >Prev</a
          >
          <a class="button is-link is-small" (click)="welcomeWindow('')"
            >Finish</a
          >
        </div>
      </div>
    </div>
    }
  </div>
  <button
    class="modal-close is-large"
    (click)="welcomeWindow()"
    aria-label="close"
  ></button>
</div>
}

<router-outlet></router-outlet>
